import { render, staticRenderFns } from "./bookRightItem.vue?vue&type=template&id=b2fa726c&scoped=true"
import script from "./bookRightItem.vue?vue&type=script&lang=js"
export * from "./bookRightItem.vue?vue&type=script&lang=js"
import style0 from "./bookRightItem.vue?vue&type=style&index=0&id=b2fa726c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fa726c",
  null
  
)

export default component.exports